module.exports = __webpack_public_path__ + "static/media/012.4c114ab0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/thumbs/012.jpg
// module id = 519
// module chunks = 0